import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { getCompany, getSubcompany } from 'auth/selectors';
import * as dashboardSelectors from 'selectors/dashboard';
import { getDashboard, resetDashboard } from 'containers/dashboard/actions';

class DashboardDataContainer extends PureComponent {
  componentWillMount = () => {
    this.props.resetDashboard();
    this.fetch();
  };

  fetch = () => {
    const { company, subcompany } = this.props;
    this.props.getDashboard(company.id, subcompany.id);
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.subcompany.id !== this.props.subcompany.id) this.fetch();
  };

  render() {
    const { company, subcompany, dashboard } = this.props;
    return this.props.render({
      company,
      subcompany,
      dashboard,
      fetch: this.fetch,
    });
  }
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  dashboard: {
    totalByAccount: dashboardSelectors.getAllTotalByAccount(state),
    totalByCostCenter: dashboardSelectors.getAllTotalByCostCenter(state),
    totalByStatus: dashboardSelectors.getAllTotalByStatus(state),
    amountByCostCenter: dashboardSelectors.getAllAmountByCostCenter(state),
    assetsSummary: dashboardSelectors.getAssetsSummary(state),
  },
});

const mapDispatchToProps = { getDashboard, resetDashboard };

export default connect(mapStateToProps, mapDispatchToProps)(DashboardDataContainer);



// WEBPACK FOOTER //
// src/containers/dashboard/DashboardDataContainer.js